import { atom } from "jotai";
import NotebookRecord from "models/view-models/notebook-record";
import PageRecord from "models/view-models/page-record";

export const notebooksAtom = atom<NotebookRecord[]>([]);
export const currentNotebookAtom = atom<NotebookRecord | null | undefined>(
    null
);
export const currentPageAtom = atom<PageRecord | null>(null);
export const currentPageLoadingAtom = atom<boolean>(false);
export const notebooksLoadingAtom = atom<boolean>(true);
export const notebooksLoadedAtom = atom<boolean>(false);

export const notebookPinsLoadingAtom = atom<boolean>(false);
